/* src/app/pages/not-found/not-found.component.less */
:host {
  display: block;
}
.not-found-container {
  background:
    linear-gradient(
      to bottom,
      #fff 0%,
      #fff 40%,
      #009DB2 100%);
  width: 100%;
  height: 100vh;
}
.not-found-container .image-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
}
.not-found-container .image-container img {
  width: 55%;
}
.not-found-container .info-container {
  display: flex;
  justify-content: end;
  align-items: center;
  flex-direction: column;
  height: 25vh;
}
.not-found-container .info-container p {
  font-weight: 600;
  font-size: 20px;
  text-align: center;
  vertical-align: middle;
  color: #FFFFFF;
  width: 70%;
}
.not-found-container .info-container button {
  cursor: pointer;
  color: #FFFFFF;
  padding: 10px;
  box-shadow: 0px 4px 4px 0px #00000040;
  background-color: #007888;
  border: none;
  font-size: 20px;
  border-radius: 5px;
}
@media screen and (max-width: 1024px) {
  .not-found-container .image-container {
    align-items: end;
    height: 60vh;
  }
  .not-found-container .image-container img {
    width: 100%;
  }
  .not-found-container .info-container {
    justify-content: center;
  }
}
@media screen and (max-width: 1024px) and (max-height: 600px) {
  .not-found-container .image-container {
    align-items: end;
    height: 70vh;
  }
  .not-found-container .image-container img {
    width: 60%;
  }
}
@media screen and (max-width: 600px) {
  .not-found-container .info-container p,
  .not-found-container .info-container button {
    font-size: 16px;
  }
  .not-found-container .info-container p {
    width: 100%;
  }
}
/*# sourceMappingURL=not-found.component-EXISOHMG.css.map */
